// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-party {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.order-party-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  background: #f1f5f9;
  flex-shrink: 0;
}

.order-party-avatar--empty {
  display: inline-block;
  border: 1px solid #e2e8f0;
}

.orders-embedded.user-dashboard {
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/orders/orders.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".order-party {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.order-party-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  object-fit: cover;\n  background: #f1f5f9;\n  flex-shrink: 0;\n}\n\n.order-party-avatar--empty {\n  display: inline-block;\n  border: 1px solid #e2e8f0;\n}\n\n.orders-embedded.user-dashboard {\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
